<template>
  <Flex
    v-test="`logged-out-page`"
    :direction="'column'"
  >
    <BaseHeading
      size="xl"
      center
    >
      {{ $t('logged_out.heading') }}
    </BaseHeading>
    <BaseText center>
      {{ $t('logged_out.description') }}
    </BaseText>
    <div :class="$style.buttonWrap">
      <BaseButton
        :routerLink="{ name: 'login' }"
        v-test="'btn-login'"
      >
        {{ $t('logged_out.button') }}
      </BaseButton>
    </div>
  </Flex>
</template>

<style
  lang="scss"
  module
>
.buttonWrap {
  display: flex;
  justify-content: center;
}
</style>
